import {
  AppBar,
  Autocomplete,
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  Toolbar,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import ClearIcon from '@mui/icons-material/Clear';
import { DesktopDatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { lightPalette } from '../../../../theme';
import { Root, StyledMenuProps, classes } from './utils';
import CommonGrid from './CommonGrid';
import LineChart from './LineChart';
import PieChart from './PieChart';
import { getOrganizationNameAndId } from '../../../../services/organizationDetails';
import { getScanHistoryAllOrgChartData } from '../../../../services/scanHistoryApi';
import { getRowData } from '../../../../services/allInvoiceApi';
import { globalClasses } from '../../utils/globalUtils';
import Toast from '../../utils/Toast';
import {
  getModelNameForSA,
  modelSelectDropBox,
  postModelNameForSA,
} from '../../../../services/accountSetting';

const SalesReport = () => {
  const [isCard] = useState(true);
  const [selectedOrganization, setSelectedOrganization] =
    useState('All organization');
  const [chartData, setChartData] = useState(null);
  const [organizationsData, setOrganizationsData] = useState([]);
  const [typeWiseAllAccuracies, setTypeWiseAllAccuracies] = useState({});
  const [selectedModel, setSelectedModel] = useState();
  const [models, setModels] = useState([]);
  console.log(models);
  console.log(selectedModel);

  const [overAllAccuracyOfAllDocument, setOverAllAccuracyOfAllDocument] =
    useState(0);
  const [selectedAccuracyMonth, setSelectedAccuracyMonth] = useState();
  const [customStartDate, setCustomStartDate] = useState(null);
  const [customEndDate, setCustomEndDate] = useState(null);
  const today = dayjs();
  const getOrganizationOption = async () => {
    try {
      const response = await getOrganizationNameAndId();
      setOrganizationsData(response);
    } catch (err) {
      return err;
    }
  };
  const DATE_REGEX = /^(0[1-9]|1[0-2])\/(0[1-9]|[12]\d|3[01])\/\d{4}$/;

  useEffect(() => {
    getOrganizationOption();
  }, []);

  const getAllScanData = async (organizationId) => {
    const Data = await getScanHistoryAllOrgChartData(organizationId);
    if (Data) {
      setChartData(Data);
    } else {
      setChartData(null);
    }
  };

  useEffect(() => {
    getAllScanData();
  }, []);

  const handleModel = async (event) => {
    setSelectedModel(event.target.value);
    await postModelNameForSA(event.target.value);
  };
  const fetchData = async () => {
    try {
      const listData = await modelSelectDropBox();
      if (listData?.length >= 0) {
        setModels(listData);
      }
    } catch (error) {
      return error;
    }
  };
  const fetchGetModel = async () => {
    try {
      const modelData = await getModelNameForSA();
      if (modelData) {
        setSelectedModel(modelData?.model_type);
      }
    } catch (error) {
      return error;
    }
  };
  useEffect(() => {
    fetchData();
    fetchGetModel();
  }, []);
  const handleChange = (event) => {
    const { value } = event.target;
    getAllScanData(value.id);
    setSelectedOrganization(value.name);
  };

  const accuracyMonthOptions = [
    { label: 'This Month', value: 'This Month' },
    { label: 'Last Month', value: 'Last Month' },
    { label: 'Last 3 months', value: 'Last 3 months' },
    { label: 'Last 6 months', value: 'Last 6 months' },
    { label: 'Last 12 months', value: 'Last 12 months' },
    { label: 'Custom', value: 'Custom' },
  ];

  const calculateDateRange = (selectedMonth) => {
    const now = new Date();
    let startDate;
    let endDate;

    if (selectedMonth === 'This Month') {
      startDate = new Date(now.getFullYear(), now.getMonth(), 1);
      endDate = now;
    } else if (selectedMonth === 'Last Month') {
      startDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      endDate = new Date(now.getFullYear(), now.getMonth(), 0);
    } else if (selectedMonth === 'Last 3 months') {
      startDate = new Date(now.getFullYear(), now.getMonth() - 3, 1);
      endDate = now;
    } else if (selectedMonth === 'Last 6 months') {
      startDate = new Date(now.getFullYear(), now.getMonth() - 6, 1);
      endDate = now;
    } else if (selectedMonth === 'Last 12 months') {
      startDate = new Date(now.getFullYear(), now.getMonth() - 12, 1);
      endDate = now;
    } else if (selectedMonth === 'Custom') {
      startDate = customStartDate;
      endDate = customEndDate;
    }
    return { startDate, endDate };
  };

  const calculateAverageAccuracy = async () => {
    const getAllDocumentData = await getRowData({}, '', {}, {});

    const documentTypes = [
      'bank-statement',
      'CC',
      'sales',
      'invoice',
      'receipt',
    ];

    const { startDate, endDate } = calculateDateRange(selectedAccuracyMonth);

    if (selectedAccuracyMonth === 'Custom' && (!startDate || !endDate)) {
      return;
    }

    const filterByDate = (doc) => {
      if (!startDate || !endDate) return true;
      const createdAt = new Date(doc.created_at);
      return createdAt >= startDate && createdAt <= endDate;
    };

    const calculateTypeWiseAccuracy = (type) => {
      const filteredDocs = getAllDocumentData?.data?.rows?.filter(
        (doc) =>
          doc?.status === 'Completed' &&
          doc?.accuracy !== null &&
          doc?.document_type === type &&
          filterByDate(doc),
      );

      if (filteredDocs?.length === 0) {
        return null;
      }

      const totalAccuracy = filteredDocs?.reduce(
        (sum, doc) => sum + parseFloat(doc.accuracy),
        0,
      );
      let typeWiseAccuracies;
      if (filteredDocs?.length) {
        typeWiseAccuracies = totalAccuracy / filteredDocs.length;
      }
      return typeWiseAccuracies;
    };

    const typeWiseAccuracies = documentTypes?.reduce((acc, type) => {
      const accuracy = calculateTypeWiseAccuracy(type);

      let key = type;
      if (type === 'bank-statement') {
        key = 'bank-statement';
      } else if (type === 'CC') {
        key = 'creditcardstatement';
      }

      acc[key] = accuracy !== null ? accuracy?.toFixed(2) : null;
      return acc;
    }, {});

    setTypeWiseAllAccuracies(typeWiseAccuracies);

    const validAccuracies = Object.values(typeWiseAccuracies).filter(
      (accuracy) => accuracy !== null,
    );

    if (validAccuracies.length === 0) {
      return 'Not Found';
    }

    const overallAccuracy =
      validAccuracies.reduce((sum, acc) => sum + parseFloat(acc), 0) /
      validAccuracies.length;
    const finalOverallAccuracy = overallAccuracy.toFixed(2);

    setOverAllAccuracyOfAllDocument(finalOverallAccuracy);

    return {
      typeWiseAccuracies,
      overallAccuracy: finalOverallAccuracy,
    };
  };
  const currentDate = new Date();
  const handleSubmit = async () => {
    if (selectedAccuracyMonth === 'Custom') {
      if (!customStartDate || !customEndDate) {
        Toast({
          message: 'Please select both a start date and an end date.',
          variant: 'warning',
        });
        return;
      }
      const formattedStartDate = customStartDate.format('MM/DD/YYYY');
      const formattedEndDate = customEndDate.format('MM/DD/YYYY');

      if (
        !DATE_REGEX.test(formattedStartDate) ||
        !DATE_REGEX.test(formattedEndDate)
      ) {
        Toast({
          message: 'Invalid date format. Please use MM/DD/YYYY.',
          variant: 'warning',
        });
        return;
      }

      if (customStartDate > customEndDate) {
        Toast({
          message: 'Start date cannot be later than the end date.',
          variant: 'warning',
        });
        return;
      }

      if (
        customStartDate.isAfter(currentDate) ||
        customEndDate.isAfter(currentDate)
      ) {
        Toast({
          message: 'Dates cannot be in the future.',
          variant: 'warning',
        });
        return;
      }
    }
    await calculateAverageAccuracy();
  };
  useEffect(() => {
    calculateAverageAccuracy();
  }, [selectedAccuracyMonth]);

  useEffect(() => {
    calculateAverageAccuracy();
  }, []);

  return (
    <Root className={classes.root}>
      <Box className={classes.MainBox}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography
            variant="h4"
            color={lightPalette.darkPurple.main}
            mt={1.5}
            mb={6.5}
          >
            Dashboard
          </Typography>
          <FormControl sx={{ width: '200px' }}>
            <Select
              size="small"
              value={selectedModel || ''}
              onChange={handleModel}
            >
              {models?.map((list) => (
                <MenuItem
                  disabled={list?.short_desc === 'custom'}
                  value={list?.short_desc}
                  key={list?.id}
                >
                  {list?.short_desc}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Box
          mt={{
            xs: 3,
            sm: 4,
            md: 3.5,
            lg: 4.75,
            xl: 6,
            xxl: 7.25,
          }}
        >
          <CommonGrid isCard={isCard} />

          <Grid container columns={{ xs: 4, lg: 12 }}>
            <Grid item xs={8}>
              <Box className={classes.scanHistoryHeader}>
                <AppBar
                  position="static"
                  className={classes.externalHeaderAppBar}
                >
                  <Toolbar variant="dense">
                    <Typography
                      variant="h5"
                      component="div"
                      className={classes.externalHeaderTitle}
                    >
                      Scanning History
                    </Typography>

                    <FormControl className={classes.organizationSelectDropdown}>
                      <Select
                        size="small"
                        renderValue={(selected) =>
                          selected?.length > 0 ? (
                            selected
                          ) : (
                            <Typography variant="body1">
                              All Organization
                            </Typography>
                          )
                        }
                        value={selectedOrganization}
                        onChange={handleChange}
                        displayEmpty
                        MenuProps={StyledMenuProps}
                      >
                        {organizationsData?.map((organization) => (
                          <MenuItem key={organization.id} value={organization}>
                            {organization.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Toolbar>
                </AppBar>
              </Box>
              <Box>
                <LineChart
                  months={chartData?.Months}
                  scans={chartData?.Scans}
                />
              </Box>
            </Grid>
            <Grid item xs={4}>
              <Box>
                <AppBar
                  position="static"
                  className={classes.externalHeaderAppBar}
                >
                  <Toolbar variant="dense">
                    <Typography
                      variant="h5"
                      component="div"
                      className={classes.externalHeaderTitle}
                    >
                      {`Overall Accuracy: ${overAllAccuracyOfAllDocument}%`}
                    </Typography>
                    <FormControl
                      className={classes.accuracyMonthSelectDropdown}
                    >
                      <Autocomplete
                        options={accuracyMonthOptions}
                        getOptionLabel={(option) => option.label}
                        value={
                          accuracyMonthOptions.find(
                            (opt) => opt.value === selectedAccuracyMonth,
                          ) || null
                        }
                        onChange={(event, newValue) => {
                          setSelectedAccuracyMonth(
                            newValue ? newValue.value : null,
                          );
                          if (newValue && newValue.value !== 'Custom') {
                            setCustomStartDate(null);
                            setCustomEndDate(null);
                          }
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select Filter"
                            variant="outlined"
                          />
                        )}
                        size="small"
                        clearOnEscape
                        clearIcon={
                          <IconButton
                            aria-label="clear"
                            sx={{ padding: '1px' }}
                          >
                            <ClearIcon sx={{ fontSize: '5px' }} />
                          </IconButton>
                        }
                      />
                    </FormControl>
                  </Toolbar>
                </AppBar>
                {selectedAccuracyMonth === 'Custom' && (
                  <Box className={classes.dateRangeContainerBox}>
                    <Box className={globalClasses.displayFlex}>
                      <Box
                        className={`${classes.dateRangeLabelBox} ${classes.datePickerHeight}`}
                      >
                        <Typography variant="h5" component="div">
                          From:
                        </Typography>
                      </Box>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          value={customStartDate}
                          maxDate={today}
                          onChange={(newDate) => setCustomStartDate(newDate)}
                          clearable
                          required
                          reduceAnimations
                          format="MM/DD/YYYY"
                          className={`${classes.fromDatePicker} ${classes.datePickerHeight} ${classes.datePickerWidth}`}
                          slotProps={{
                            field: {
                              clearable: true,
                              size: 'small',
                              error: false,
                            },
                            // textField: {
                            //   inputProps: {
                            //     readOnly: true,
                            //   },
                            // },
                          }}
                        />
                      </LocalizationProvider>
                    </Box>
                    <Box className={globalClasses.displayFlex}>
                      <Box
                        className={`${classes.dateRangeLabelBox} ${classes.datePickerHeight}`}
                      >
                        <Typography variant="h5" component="div">
                          To:
                        </Typography>
                      </Box>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DesktopDatePicker
                          value={customEndDate}
                          minDate={customStartDate}
                          maxDate={today}
                          onChange={(newDate) => setCustomEndDate(newDate)}
                          clearable
                          required
                          reduceAnimations
                          format="MM/DD/YYYY"
                          className={`${classes.datePickerWidth} ${classes.datePickerHeight}`}
                          slotProps={{
                            field: {
                              clearable: true,
                              size: 'small',
                              error: false,
                            },
                            // textField: {
                            //   inputProps: {
                            //     readOnly: true,
                            //   },
                            // },
                          }}
                        />
                      </LocalizationProvider>
                    </Box>
                    <Button
                      variant="contained"
                      className={classes.submitButton}
                      style={{ marginTop: '12px' }}
                      onClick={handleSubmit}
                    >
                      Submit
                    </Button>
                  </Box>
                )}
              </Box>
              <PieChart typeWiseAllAccuracies={typeWiseAllAccuracies} />
            </Grid>
          </Grid>
          <CommonGrid />
        </Box>
      </Box>
    </Root>
  );
};

export default SalesReport;
